module.exports = __webpack_public_path__ + "static/media/provider4.9ebcef63.png";